import { type Shift } from "@src/appV2/Shifts/Shift/types";

import { MIN_SHIFT_LENGTH_FOR_MANDATORY_BREAK_IN_MINUTES } from "../Shift/constants";
import { getScheduledShiftDurationInMinutes } from "./getScheduledShiftDuration";

/**
 * Returns whether a shift requires a mandatory break based on its duration and facility settings.
 */
export function doesShiftInProgressAllowBreakAction(
  shift: Pick<Shift, "start" | "end">,
  isWorkplaceMandatoryBreakEnabled: boolean
): boolean {
  // If the workplace requires a mandatory break we automatically add it for them, and don't
  // give the Worker break action buttons (i.e. start/end/skip break)
  if (isWorkplaceMandatoryBreakEnabled) {
    return false;
  }

  const shiftDurationInMinutes = getScheduledShiftDurationInMinutes(shift);

  return shiftDurationInMinutes > MIN_SHIFT_LENGTH_FOR_MANDATORY_BREAK_IN_MINUTES;
}
